var _rect, _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4848 -9711C-4848 -9764.02 -4805.02 -9807 -4752 -9807H12190C12243 -9807 12286 -9764.02 12286 -9711V19183C12286 19236 12243 19279 12190 19279H-4752C-4805.02 19279 -4848 19236 -4848 19183V-9711Z",
    fill: "#EEF6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4752 -9792H12190V-9822H-4752V-9792ZM12271 -9711V19183H12301V-9711H12271ZM12190 19264H-4752V19294H12190V19264ZM-4833 19183V-9711H-4863V19183H-4833ZM-4752 19264C-4796.74 19264 -4833 19227.7 -4833 19183H-4863C-4863 19244.3 -4813.3 19294 -4752 19294V19264ZM12271 19183C12271 19227.7 12234.7 19264 12190 19264V19294C12251.3 19294 12301 19244.3 12301 19183H12271ZM12190 -9792C12234.7 -9792 12271 -9755.74 12271 -9711H12301C12301 -9772.3 12251.3 -9822 12190 -9822V-9792ZM-4752 -9822C-4813.3 -9822 -4863 -9772.3 -4863 -9711H-4833C-4833 -9755.74 -4796.74 -9792 -4752 -9792V-9822Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-2618 -449C-2618 -484.346 -2589.35 -513 -2554 -513H6670C6705.35 -513 6734 -484.346 6734 -449V1831C6734 1866.35 6705.35 1895 6670 1895H-2554C-2589.35 1895 -2618 1866.35 -2618 1831V-449Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2554 -503H6670V-523H-2554V-503ZM6724 -449V1831H6744V-449H6724ZM6670 1885H-2554V1905H6670V1885ZM-2608 1831V-449H-2628V1831H-2608ZM-2554 1885C-2583.82 1885 -2608 1860.82 -2608 1831H-2628C-2628 1871.87 -2594.87 1905 -2554 1905V1885ZM6724 1831C6724 1860.82 6699.82 1885 6670 1885V1905C6710.87 1905 6744 1871.87 6744 1831H6724ZM6670 -503C6699.82 -503 6724 -478.823 6724 -449H6744C6744 -489.869 6710.87 -523 6670 -523V-503ZM-2554 -523C-2594.87 -523 -2628 -489.869 -2628 -449H-2608C-2608 -478.823 -2583.82 -503 -2554 -503V-523Z",
    fill: "#5DA5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_44749)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -758,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -758,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "url(#paint0_linear_378_44749)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_378_44749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-309 3.8147e-06C-309 -16.0163 -296.016 -29 -280 -29H73V394C73 410.016 60.0163 423 44 423H-280C-296.016 423 -309 410.016 -309 394V3.8147e-06Z",
    fill: "#EFF9F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309 3.8147e-06C-309 -16.0163 -296.016 -29 -280 -29H73V394C73 410.016 60.0163 423 44 423H-280C-296.016 423 -309 410.016 -309 394V3.8147e-06Z",
    stroke: "#60C2A5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#007580"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_378_44749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0008 10.675C15.7383 10.675 10.6758 15.7375 10.6758 22C10.6758 28.2626 15.7383 33.3625 22.0008 33.3625C28.2633 33.3625 33.3633 28.2626 33.3633 22C33.3633 15.7375 28.2633 10.675 22.0008 10.675ZM22.0008 31.675C16.6758 31.675 12.3633 27.325 12.3633 22C12.3633 16.675 16.6758 12.3625 22.0008 12.3625C27.3258 12.3625 31.6758 16.7125 31.6758 22.0375C31.6758 27.325 27.3258 31.675 22.0008 31.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2256 18.5125L20.7631 22.8625L18.7381 20.875C18.4006 20.5375 17.8756 20.575 17.5381 20.875C17.2006 21.2125 17.2381 21.7375 17.5381 22.075L19.9381 24.4C20.1631 24.625 20.4631 24.7375 20.7631 24.7375C21.0631 24.7375 21.3631 24.625 21.5881 24.4L26.4256 19.75C26.7631 19.4125 26.7631 18.8875 26.4256 18.55C26.0881 18.2125 25.5631 18.2125 25.2256 18.5125Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_44749",
    x1: -118,
    y1: -367,
    x2: -118,
    y2: 165.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F7FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -758,
    y: -367,
    width: 1280,
    height: 850,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 861,
    fill: "white",
    transform: "translate(-758 -317)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleIcon);
export default __webpack_public_path__ + "static/media/CheckmarkCircleIcon.b61023bfb113bf0276c952149df580a2.svg";
export { ForwardRef as ReactComponent };